import request from '@/utils/request'
import axios from 'axios'
import envs from '@/envs'
import tokenStore from '@/utils/TokenManager/tokenStore';

// 공통 코드 조회
// parameter ex.
// var param = {"codeGroup" : "FAQ"}
export function getCommonCode (param) {
  return request({
    url: '/code/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: param
  })
}

// 환불계좌 은행 목록
export function getBankAccount() {
	return request({
		url: '/pg/fixed/get/virtualBankCode',
		method: 'post',
		headers: { 'Content-Type': 'application/json' },
		data: {},
	});
}

// 업태 목록 조회
// parameter ex.
// var param = {}
export function getBusinessCode (param) {
  return request({
    url: '/codeBusiness/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: param
  })
}

// 업종 목록 조회
// parameter ex.
// var param = {"businessCode" : "BIZDEPT_1"}
export function getSectorCode (param) {
  return request({
    url: '/codeSector/list',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: param
  })
}

export function manualInfo (data) {
  return request({
    url: '/file/manual/info',
    method: 'post',
    data
  })
}

export function manualDownload (param) {
  let baseURL = envs.buildUrl
  if (process.env.NODE_ENV === 'development') {
    baseURL = envs.devUrl
  }
  return axios({
    baseURL: baseURL,
    url: '/file/manual/download',
    method: 'get',
    params: param,
    responseType: 'blob'
  })
}

/* 파일다운로드 */
export function filedownload (param) {
  let baseURL = envs.buildUrl
  if (process.env.NODE_ENV === 'development') {
    baseURL = envs.devUrl
  }
  return axios({
    baseURL: baseURL,
    url: '/file/download',
    method: 'get',
    params: param,
    responseType: 'blob'
  })
}

 /* (통장사본) 파일다운로드 */
export function privacyFileDownload(param) {
	let baseURL = envs.buildUrl;
	if (process.env.NODE_ENV === 'development') {
		baseURL = envs.devUrl;
	}
	return axios({
		baseURL: baseURL,
		headers: {
			Authorization: tokenStore.get().accessToken,
		},
		url: '/file/privacyFileDownload',
		method: 'get',
		params: param,
		responseType: 'blob',
	});
}